
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/finishing-touches",
      function () {
        return require("private-next-pages/finishing-touches/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/finishing-touches"])
      });
    }
  